import type { StaticEntityType } from "@config";
import { useMemo } from "react";
import type { ITableListDynamicVarData, ITableSettings } from "../types";
import { parseTableListDynamicVar } from "../utils";
import { TableView } from "./table.view";

interface IProps {
  entity: StaticEntityType;
}

export const TableLibrary = ({ entity }: IProps) => {
  const parsedEntity = useMemo(() => {
    const { listDynamicVariable } = entity.settings;
    if (!listDynamicVariable) return entity;

    const data = window.__SD_DATA__?.[
      listDynamicVariable
    ] as ITableListDynamicVarData;

    if (!data || data.data.length === 0) {
      return entity;
    }

    const settings = parseTableListDynamicVar({
      settings: entity.settings as ITableSettings,
      data,
    });

    return { ...entity, settings };
  }, [entity]);

  return <TableView entity={parsedEntity} />;
};
